<!-- 譲渡するボタン -->
<!-- Organisms(Dialog)を呼び出しているので単体テスト不可。一旦stortbookなし -->
<template>
  <li>
    <a @click="openDialog"> このチケットを譲渡する </a>

    <!-- 譲渡前のダイアログ -->
    <DialogBookTransferAlert ref="DialogBookTransferAlert" />
  </li>
</template>

<script>
import DialogBookTransferAlert from "@/views/Components/Organisms/MyTickets/Dialog/DialogBookTransferAlert";

export default {
  name: "BFaceTransferButton",
  components: {
    DialogBookTransferAlert: DialogBookTransferAlert,
  },
  methods: {
    openDialog() {
      this.$refs.DialogBookTransferAlert.openDialog();
    },
  },
};
</script>

<style lang="scss" scoped></style>
